export const getOrganizationPageLink = (organizationAlias: string) => `/zaimy/mfo/${organizationAlias}/`;
